import cookie from "js-cookie";
import apiUser from "@/api/user";

import OverBooking from "@/views/MasterClasses/Overbooking";
import timeSetting from "@/views/TimeSetting";
import Redis from "@/views/Admin/Redis";
import ratingSetting from "@/views/Admin/RatingSetting";

let role = cookie.get("role");

async function redirect(next, pathType) {
  if (!role) {
    await apiUser.userInfo();
    role = cookie.get("role");
  }
  if (role !== "admin" && !pathType.includes(role)) {
    next("/error-page?code=403");
  } else {
    next();
  }
}

export default [
  {
    path: "/time-setting",
    component: timeSetting,
    meta: {
      tabTitle: "Booking | Time Setting",
    },
    beforeEnter(to, from, next) {
      to.params.fromPath = from.path;
      redirect(next, "admin");
    },
    name: "timeSetting",
  },
  {
    path: "/overbooking",
    name: "overbooking",
    component: OverBooking,
    meta: {
      tabTitle: "Booking | Overbooking Settings",
    },
    beforeEnter(to, from, next) {
      to.params.fromPath = from.path;
      redirect(next, "admin");
    },
  },
  {
    path: "/admin-redis",
    name: "adminRedis",
    component: Redis,
    meta: {
      tabTitle: "Booking | Redis Settings",
    },
    beforeEnter(to, from, next) {
      to.params.fromPath = from.path;
      redirect(next, "admin");
    },
  },
  {
    path: "/rating-setting",
    name: "ratingSetting",
    component: ratingSetting,
    meta: {
      tabTitle: "Booking | Rating Settings",
    },
    beforeEnter(to, from, next) {
      to.params.fromPath = from.path;
      redirect(next, "admin");
    },
  },
];
